import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_COMMISSION_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'

const commissionReport = {
  namespaced: true,
  state: buildInitialState({
    commissionReportItems: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearCommissionReportItems: (state) => {
      state.commissionReportItems = []
    },
    setCommissionReportItems: (state, commissionReportItems) => {
      state.commissionReportItems = commissionReportItems
    },
    setPaginatedCommissionReportItems (state, { result, totalRecords }) {
      state.commissionReportItems = result
      state.totalRecords = totalRecords
    }
  },
  actions: {
    getCommissionReportWithFiltersPaginated: ({ dispatch, rootGetters }, paginationParams = {}) => {
      return dispatch('getCommissionReportItemsPaginated', {
        ...rootGetters['commissionReportFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getCommissionReportItemsPaginated: createPaginatedGetAction(PATH_COMMISSION_REPORT, 'setPaginatedCommissionReportItems', 'Unable to get commission data'),
    getCommissionReportItems: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting commission data, please wait...' })
      return api.doGet({ path: PATH_COMMISSION_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setCommissionReportItems', data)
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get commission data')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getCommissionReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getCommissionReportItems', { ...rootGetters['commissionReportFilters/getSearchObject'] })
    }
  }
}

export default commissionReport
